import React from "react";

const Block = ({ title, children }) => (
  <section className="mt-8"><h2 className="font-display text-xl font-semibold">{title}</h2><div className="mt-2 space-y-2 text-sm leading-relaxed text-muted-foreground">{children}</div></section>
);

export default function Terms() {
  return (
    <div className="mx-auto max-w-2xl px-5 pt-10 md:pt-14">
      <h1 className="font-display text-3xl font-semibold tracking-tight md:text-4xl">Terms & Disclaimers</h1>
      <Block title="Nature of the service">
        <p>Jaanlo offers readings based on traditional and spiritual systems — Vedic astrology, numerology and tarot — for personal reflection and entertainment. These systems are traditional belief systems and are not scientifically validated.</p>
      </Block>
      <Block title="Not professional advice">
        <p>Readings are for reflection only. They are not financial, legal, medical or psychological advice, and do not guarantee any future outcome. For financial questions in particular: this reading is for personal reflection and entertainment, is not financial advice, and does not guarantee future financial outcomes.</p>
      </Block>
      <Block title="What we will never claim">
        <p>We do not provide guaranteed financial outcomes, guaranteed marriage dates, pregnancy, medical or death predictions, and we never present curses or black magic as facts. We do not use fear-based messaging or hidden subscriptions.</p>
      </Block>
      <Block title="Payments">
        <p>All readings are one-time microtransactions. There are no mandatory subscriptions. Prices are shown clearly before purchase.</p>
      </Block>
      <Block title="Use responsibly">
        <p>Always compare any reflection with your real circumstances and your own judgement before making decisions.</p>
      </Block>
    </div>
  );
}
